export default {
    removeHeader: Symbol('removeHeader'),
};
//# sourceMappingURL=wellKnownSymbols.js.map